/* =============================================================
   Fi Akla — Delivery + Allergy Gate (assets/fi-akla-delivery-slot.js)
   Single source of truth for required cart declarations.
   Cart attributes are the only source of truth for persistence.
   ============================================================= */
 
/* ── Global duplicate-init guard ─────────────────────────────
   The entire script is skipped if it has already run.
   This covers listeners, MutationObserver and timers.        */
if (window.fiAklaDeliverySlotLoaded) {
  // Script already initialised — do nothing.
} else {
  window.fiAklaDeliverySlotLoaded = true;
 
  (function () {
    'use strict';
 
    /* ── Constants ─────────────────────────────────────────── */
 
    var ALLERGENS = [
      'Peanuts',
      'Tree nuts',
      'Eggs',
      'Dairy',
      'Sesame',
      'Fish',
      'Soy',
      'Shellfish',
      'Celery',
      'Wheat',
      'Mustard'
    ];
 
    /* ── Locale-aware cart route helper ────────────────────── */
 
    function getCartRoute(path) {
      var root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      return root + path;
    }
 
    /* ── Shared mutable state ──────────────────────────────── */
 
    var slotPersisted       = false;
    var allergyPersisted    = false;
    var pendingSlotSave     = null;
    var pendingAllergySave  = null;
    var pendingRoutingSave  = null;
    var changeSeq           = 0;
    var allergySeq          = 0;
    var initSeq             = 0;
    var allergyInputTimer   = null;
    var cartMode             = 'empty';
    var orderTypes = '';
    var chefBookingsReady = true;
    var compositionKnown     = false;
    var routingPersisted     = false;
 
    /* ── Option list ───────────────────────────────────────── */

    function localizeWindowLabel(label) {
      if (!/^ar(?:-|$)/i.test((window.FiAklaDeliverySchedule && window.FiAklaDeliverySchedule.config && window.FiAklaDeliverySchedule.config.locale) || '')) {
        return label;
      }

      return String(label || '')
        .replace(/\bAM\b/g, 'ص')
        .replace(/\bPM\b/g, 'م')
        .replace(/[0-9]/g, function (digit) {
          return '٠١٢٣٤٥٦٧٨٩'[Number(digit)];
        });
    }

    function buildOptions() {
      var schedule = window.FiAklaDeliverySchedule;
      var selectLabel = schedule && schedule.config && schedule.config.strings
        ? schedule.config.strings.selectSlot
        : 'Select a delivery slot';
      var options = [
        { value: '', text: selectLabel, date: '', window: '', disabled: true }
      ];
      if (!schedule) return options;
      schedule.getAvailableDeliveries(Date.now(), 2).forEach(function (delivery) {
        var dateLabel = schedule.formatDate(delivery.date);
        (delivery.slots || []).forEach(function (w) {
          var slotLabel = dateLabel + ' · ' + w.label;
          var displayLabel = dateLabel + ' · ' + localizeWindowLabel(w.label);
          options.push({ value: slotLabel, text: displayLabel, date: delivery.date, window: w.window, disabled: false });
        });
      });
      return options;
    }
 
    function findOption(value, options) {
      for (var i = 0; i < options.length; i++) {
        if (options[i].value === value) return options[i];
      }
      return null;
    }
 
    /* ── DOM helpers ───────────────────────────────────────── */
 
    function getSelect() {
      return (
        document.getElementById('CartDrawer-DeliverySlot') ||
        document.querySelector('select[name="attributes[Delivery slot]"]')
      );
    }
 
    function getAllergyFieldset() {
      return document.getElementById('CartDrawer-AllergyDeclaration');
    }
 
    function getAllergyStatus() {
      return document.querySelector('input[name="fi-akla-allergy-status"]:checked');
    }
 
    function getAllergenInputs() {
      return Array.prototype.slice.call(
        document.querySelectorAll('input[name="fi-akla-allergen"]')
      );
    }
 
    function getAllergyOtherInput() {
      return document.querySelector('[data-allergy-other-text]');
    }
 
    function getAllergyNotesInput() {
      return document.querySelector('[data-allergy-notes]');
    }

    function getAllergyProfileSaveInput() {
      return document.querySelector('[data-allergy-profile-save]');
    }
 
    function getCheckout(selectEl) {
      /* Try scoped lookup inside the nearest cart container first */
      if (selectEl) {
        var container = selectEl.closest(
          'cart-drawer, [id*="cart-drawer"], .cart-drawer, ' +
          '.cart-drawer__summary, .cart__summary, [data-cart-summary]'
        );
        if (container) {
          var scoped = container.querySelector('button[name="checkout"][form="cart-form"]');
          if (scoped) return scoped;
        }
      }
      /* Global fallback */
      return (
        document.getElementById('checkout') ||
        document.querySelector('button[name="checkout"][form="cart-form"]')
      );
    }
 
    function isServiceItem(item) {
      var properties = item && item.properties ? item.properties : {};
      return !!(item && (
        item.product_type === 'Service' ||
        properties['_Booking type'] === 'Invite Us Over' ||
        properties['_Booking type'] === 'Invite Us Over add-on' ||
        /^invite-us-over-/.test(item.handle || '')
      ));
    }

    function isMealPassItem(item) {
      return !!(item && (
        item.product_type === 'Meal Pass' ||
        item.handle === 'fi-akla-meal-pass' ||
        /^PASS-(LIGHT|REGULAR|FULL)-(4W|8W|12W)$/.test(item.sku || '')
      ));
    }

    function getCartMode(cart) {
      chefBookingsReady = true;
      var hasService = false;
      var hasWeekly = false;
      var hasMealPass = false;
      var items = cart && cart.items ? cart.items : [];
      for (var i = 0; i < items.length; i++) {
        if (isServiceItem(items[i])) {
          hasService = true;
          var props = items[i].properties || {};
          var addon = props['_Booking type'] === 'Invite Us Over add-on';
          var reserved = props['_Fi Akla booking handoff'] || props.Booking ||
            ((props['Appointment date'] || props['_Fi Akla Appointment date']) && (props['Arrival time'] || props['_Fi Akla Arrival time']));
          if (addon) {
            var parentExists = items.some(function (parent) {
              var p = parent.properties || {};
              return p['_Booking type'] !== 'Invite Us Over add-on' && p['_Booking group'] && p['_Booking group'] === props['_Booking group'];
            });
            if (!parentExists) chefBookingsReady = false;
          } else if (!reserved) chefBookingsReady = false;
        }
        else if (isMealPassItem(items[i])) hasMealPass = true;
        else hasWeekly = true;
      }
      orderTypes = [hasWeekly && 'weekly-meal', hasService && 'invite-us-over', hasMealPass && 'meal-pass'].filter(Boolean).join(',');
      if (hasWeekly) return 'weekly';
      if (hasService) return 'service';
      if (hasMealPass) return 'meal-pass';
      return 'empty';
    }

    function getRoutingAttributes(mode) {
      var lifecycle = '';
      if (mode === 'weekly') lifecycle = 'weekly-meal';
      else if (mode === 'service') lifecycle = 'invite-us-over';
      else if (mode === 'meal-pass') lifecycle = 'meal-pass';
      else if (mode === 'mixed') lifecycle = 'mixed';
      if (!lifecycle) return null;

      var language = String(document.documentElement.lang || 'en')
        .toLowerCase()
        .split('-')[0];
      if (language !== 'ar') language = 'en';

      return {
        'Fi Akla lifecycle': lifecycle,
        'Fi Akla language': language,
        'Fi Akla order types': orderTypes
      };
    }

    function syncRoutingInputs(attributes) {
      var values = attributes || {
        'Fi Akla lifecycle': '',
        'Fi Akla language': ''
      };
      var details = document.querySelector('[data-fi-akla-cart-mode]');
      if (details) {
        details.setAttribute(
          'data-fi-akla-routing',
          values['Fi Akla lifecycle'] + ':' + values['Fi Akla language']
        );
      }
      Object.keys(values).forEach(function (key) {
        var input = document.querySelector('input[name="attributes[' + key + ']"]');
        if (!input) return;
        input.value = values[key];
        input.setAttribute('value', values[key]);
      });
    }

    function reinforceRoutingInputs(attributes) {
      [0, 250, 1000, 2500].forEach(function (delay) {
        window.setTimeout(function () {
          syncRoutingInputs(attributes);
        }, delay);
      });
    }

    function persistRoutingAttributes(cart, sequence) {
      var desired = getRoutingAttributes(cartMode);
      if (!desired) {
        syncRoutingInputs(null);
        routingPersisted = cartMode === 'empty';
        return Promise.resolve(cart);
      }

      /* Keep the normal cart form as a fallback to the Ajax persistence. */
      syncRoutingInputs(desired);
      reinforceRoutingInputs(desired);

      var saved = cart.attributes || {};
      if (
        saved['Fi Akla lifecycle'] === desired['Fi Akla lifecycle'] &&
        saved['Fi Akla language'] === desired['Fi Akla language'] &&
        saved['Fi Akla order types'] === desired['Fi Akla order types']
      ) {
        routingPersisted = true;
        return Promise.resolve(cart);
      }

      routingPersisted = false;
      pendingRoutingSave = { seq: sequence };
      updateCheckoutState(getSelect());
      return updateCartAttributes(desired).then(function (updatedCart) {
        pendingRoutingSave = null;
        if (sequence !== initSeq) return null;
        syncRoutingInputs(desired);
        reinforceRoutingInputs(desired);
        routingPersisted = true;
        showError('CartDrawer-RoutingSaveError', false);
        return updatedCart;
      });
    }

    function syncCartModeUI() {
      var details = document.querySelector('[data-fi-akla-cart-mode]');
      if (details) details.setAttribute('data-fi-akla-cart-mode', cartMode);
      var slotWrap = document.querySelector('.cart-delivery-slot');
      if (slotWrap) slotWrap.hidden = cartMode !== 'weekly';
      var allergyFieldset = getAllergyFieldset();
      if (allergyFieldset) allergyFieldset.hidden = cartMode !== 'weekly';
      showError('FiAkla-IncompleteChefBooking', !chefBookingsReady);
      var mixedError = document.getElementById('CartDrawer-MixedCartError');
      if (mixedError) mixedError.hidden = cartMode !== 'mixed';
    }

    function setSelectDisabled(disabled) {
      var el = getSelect();
      if (el) el.disabled = disabled;
    }
 
    function setAllergyControlsDisabled(disabled) {
      var fieldset = getAllergyFieldset();
      if (!fieldset) return;
 
      fieldset.setAttribute('aria-busy', disabled ? 'true' : 'false');
      var controls = fieldset.querySelectorAll('input, textarea');
      for (var i = 0; i < controls.length; i++) {
        controls[i].disabled = disabled || controls[i].hasAttribute('data-allergy-unavailable');
      }
    }
 
    function updateCheckoutState(contextEl) {
      var checkouts = Array.prototype.slice.call(document.querySelectorAll('button[name="checkout"][form="cart-form"]'));
      if (!checkouts.length) {
        var fallback = getCheckout(contextEl);
        if (fallback) checkouts.push(fallback);
      }
      if (!checkouts.length) return;
 
      var mealPassReady = cartMode === 'meal-pass';
      var slotReady =
        cartMode === 'service' ||
        mealPassReady ||
        (cartMode === 'weekly' && slotPersisted);
      var allergyReady = cartMode !== 'weekly' || (allergyPersisted && readAllergyUI().valid);
      var contactReady =
        cartMode !== 'weekly' ||
        !window.FiAklaCartDetails ||
        window.FiAklaCartDetails.isReady();
      var cleanupPending = window.FiAklaCartIntegrity &&
        window.FiAklaCartIntegrity.isCleanupPending &&
        window.FiAklaCartIntegrity.isCleanupPending();
      var disabled = checkoutInProgress || cartUpdating || cleanupPending || !(
        compositionKnown && chefBookingsReady &&
        routingPersisted &&
        cartMode !== 'empty' &&
        slotReady &&
        allergyReady && contactReady &&
        pendingSlotSave === null &&
        pendingAllergySave === null &&
        pendingRoutingSave === null
      );
      checkouts.forEach(function (checkout) { checkout.disabled = disabled; });
    }
 
    function showError(id, visible) {
      var el = document.getElementById(id);
      if (el) el.hidden = !visible;
    }
 
    /* ── Populate the <select> ─────────────────────────────── */
 
    function populateSelector(options, restoredValue) {
      var select = getSelect();
      if (!select) return;
 
      select.innerHTML = '';
      options.forEach(function (opt) {
        var el         = document.createElement('option');
        el.value       = opt.value;
        el.textContent = opt.text;
        if (opt.disabled) el.disabled = true;
        select.appendChild(el);
      });
 
      if (restoredValue && findOption(restoredValue, options)) {
        select.value = restoredValue;
      } else {
        select.value = '';
        if (select.options.length) select.options[0].selected = true;
      }
    }
 
    /* ── Cart API ──────────────────────────────────────────── */
 
    function updateCartAttributes(attrs) {
      return window.FiAklaCartIntegrity.updateAttributes(attrs);
    }
 
    function saveSlot(slotLabel, isoDate, windowStr) {
      return updateCartAttributes({
        'Delivery slot':    slotLabel,
        '_delivery_date':   isoDate,
        '_delivery_window': windowStr
      });
    }
 
    function clearSlot() {
      return updateCartAttributes({
        'Delivery slot':    '',
        '_delivery_date':   '',
        '_delivery_window': ''
      });
    }
 
    function fetchCartState() {
      return fetch(getCartRoute('cart.js'), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }
 
    /* ── Allergy declaration helpers ───────────────────────── */
 
    function hideAllergyErrors() {
      showError('CartDrawer-AllergyDeclarationError', false);
      showError('CartDrawer-AllergySelectionError',   false);
      showError('CartDrawer-AllergyOtherError',       false);
      showError('CartDrawer-AllergySaveError',        false);
    }
 
    function syncAllergyVisibility() {
      var status       = getAllergyStatus();
      var details      = document.getElementById('CartDrawer-AllergyDetails');
      var otherWrap    = document.getElementById('CartDrawer-AllergyOtherWrap');
      var yesInput     = document.querySelector('[data-allergy-yes]');
      var otherControl = document.querySelector('[data-allergen-other]');
      var profileSaveWrap = document.querySelector('[data-allergy-profile-save-wrap]');
      var profileSaveInput = getAllergyProfileSaveInput();
      var showDetails  = !!(status && status.value === 'Allergies declared');
      var showOther    = !!(showDetails && otherControl && otherControl.checked);
      var showProfileSave = !!(status && status.value !== 'Same as before');
 
      if (details) details.hidden = !showDetails;
      if (otherWrap) otherWrap.hidden = !showOther;
      if (yesInput) yesInput.setAttribute('aria-expanded', showDetails ? 'true' : 'false');
      if (otherControl) otherControl.setAttribute('aria-expanded', showOther ? 'true' : 'false');
      if (profileSaveWrap) profileSaveWrap.hidden = !showProfileSave;
      if (profileSaveInput && !showProfileSave) profileSaveInput.checked = false;
      var otherInput = getAllergyOtherInput();
      if (otherInput) otherInput.required = showOther;
    }
 
    function clearAllergyUI() {
      var statuses = document.querySelectorAll('input[name="fi-akla-allergy-status"]');
      var allergens = getAllergenInputs();
      var other = getAllergyOtherInput();
      var notes = getAllergyNotesInput();
      var profileSave = getAllergyProfileSaveInput();
      var i;
 
      for (i = 0; i < statuses.length; i++) statuses[i].checked = false;
      for (i = 0; i < allergens.length; i++) allergens[i].checked = false;
      if (other) other.value = '';
      if (notes) notes.value = '';
      if (profileSave) profileSave.checked = false;
      syncAllergyVisibility();
    }
 
    function parseStoredAllergies(rawValue) {
      var result = { standard: [], other: '' };
      if (!rawValue) return result;
 
      var pieces = rawValue.split(',');
      var otherPieces = [];
      var readingOther = false;
 
      for (var i = 0; i < pieces.length; i++) {
        var piece = pieces[i].trim();
        if (!piece) continue;
 
        if (piece.indexOf('Other:') === 0) {
          readingOther = true;
          otherPieces.push(piece.slice(6).trim());
        } else if (!readingOther && ALLERGENS.indexOf(piece) !== -1) {
          result.standard.push(piece);
        } else {
          readingOther = true;
          otherPieces.push(piece);
        }
      }
 
      result.other = otherPieces.join(', ').trim();
      return result;
    }
 
    function readAllergyUI() {
      var statusInput = getAllergyStatus();
      var result = {
        valid: false,
        status: '',
        allergies: '',
        notes: '',
        previousStatus: '',
        errorId: 'CartDrawer-AllergyDeclarationError',
        focusEl: document.querySelector('input[name="fi-akla-allergy-status"]')
      };
 
      if (!statusInput || statusInput.hasAttribute('data-allergy-unavailable')) return result;
 
      result.status = statusInput.value;
 
      if (result.status === 'No known allergies') {
        result.valid = true;
        result.allergies = '';
        result.notes = '';
        result.errorId = '';
        result.focusEl = null;
        return result;
      }

      if (result.status === 'Same as before') {
        var savedStatus = statusInput.getAttribute('data-saved-allergy-status') || '';
        if (savedStatus !== 'No known allergies' && savedStatus !== 'Allergies declared') return result;
        result.valid = true;
        result.allergies = statusInput.getAttribute('data-saved-allergies') || '';
        result.notes = statusInput.getAttribute('data-saved-allergy-notes') || '';
        result.previousStatus = statusInput.getAttribute('data-saved-allergy-status') || '';
        result.errorId = '';
        result.focusEl = null;
        return result;
      }
 
      var selected = getAllergenInputs().filter(function (input) {
        return input.checked;
      });
 
      if (selected.length === 0) {
        result.errorId = 'CartDrawer-AllergySelectionError';
        result.focusEl = getAllergenInputs()[0] || statusInput;
        return result;
      }
 
      var values = [];
      var otherSelected = false;
      for (var i = 0; i < selected.length; i++) {
        if (selected[i].value === 'Other') {
          otherSelected = true;
        } else {
          values.push(selected[i].value);
        }
      }
 
      var otherInput = getAllergyOtherInput();
      var otherText = otherInput ? otherInput.value.trim() : '';
      if (otherSelected && !otherText) {
        result.errorId = 'CartDrawer-AllergyOtherError';
        result.focusEl = otherInput;
        return result;
      }
 
      if (otherSelected) values.push('Other: ' + otherText);
 
      var notesInput = getAllergyNotesInput();
      result.valid = true;
      result.allergies = values.join(', ');
      result.notes = notesInput ? notesInput.value.trim() : '';
      result.errorId = '';
      result.focusEl = null;
      return result;
    }
 
    function restoreAllergyUI(attrs) {
      clearAllergyUI();
 
      var status = attrs['Allergy status'] || '';
      var rawAllergies = attrs['Allergies'] || '';
      var notes = attrs['Allergy notes'] || '';
      var previousStatus = attrs['Allergy previous status'] || '';
      var saveToProfile = attrs['Save allergies to My Fridge'] === 'Yes';
      var statusInput = document.querySelector(
        'input[name="fi-akla-allergy-status"][value="' + status + '"]'
      );
 
      if (!statusInput || statusInput.hasAttribute('data-allergy-unavailable')) return false;
      statusInput.checked = true;
 
      if (status === 'Allergies declared') {
        var parsed = parseStoredAllergies(rawAllergies);
        var allergenInputs = getAllergenInputs();
        for (var i = 0; i < allergenInputs.length; i++) {
          if (parsed.standard.indexOf(allergenInputs[i].value) !== -1) {
            allergenInputs[i].checked = true;
          }
          if (allergenInputs[i].value === 'Other' && parsed.other) {
            allergenInputs[i].checked = true;
          }
        }
 
        var otherInput = getAllergyOtherInput();
        if (otherInput) otherInput.value = parsed.other;
        var notesInput = getAllergyNotesInput();
        if (notesInput) notesInput.value = notes;
      }

      var profileSaveInput = getAllergyProfileSaveInput();
      if (profileSaveInput) profileSaveInput.checked = saveToProfile && status !== 'Same as before';
 
      syncAllergyVisibility();
      var current = readAllergyUI();
 
      if (status === 'No known allergies' || status === 'Same as before') {
        if (status === 'No known allergies') {
          return current.valid && !rawAllergies && !notes && !previousStatus;
        }
        return current.valid && current.allergies === rawAllergies && current.notes === notes && current.previousStatus === previousStatus;
      }
 
      return current.valid && current.allergies === rawAllergies && current.notes === notes;
    }
 
    function saveAllergyDeclaration(status, allergies, notes, previousStatus, saveToProfile) {
      return updateCartAttributes({
        'Allergy status': status,
        'Allergies':      allergies,
        'Allergy notes':  notes,
        'Allergy previous status': previousStatus || '',
        'Save allergies to My Fridge': saveToProfile ? 'Yes' : ''
      });
    }
 
    function showAllergyValidationError(result) {
      hideAllergyErrors();
      if (result && result.errorId) showError(result.errorId, true);
      if (result && result.focusEl) result.focusEl.focus();
    }
 
    function persistAllergyFromUI(showValidation) {
      hideAllergyErrors();
      syncAllergyVisibility();
 
      var result = readAllergyUI();
      allergyPersisted = false;
      allergySeq += 1;
      initSeq += 1;
      var myAllergySeq = allergySeq;
 
      if (!result.valid && showValidation) {
        showAllergyValidationError(result);
      }
 
      /* Clear any previously saved declaration when the new UI is incomplete. */
      var attrs = result.valid
        ? {
            status: result.status,
            allergies: result.allergies,
            notes: result.notes,
            previousStatus: result.previousStatus,
            saveToProfile: !!(getAllergyProfileSaveInput() && getAllergyProfileSaveInput().checked && result.status !== 'Same as before')
          }
        : { status: '', allergies: '', notes: '', previousStatus: '', saveToProfile: false };
 
      /* With no selection at all, there is nothing stale to clear on first load. */
      if (!result.valid && !result.status) {
        pendingAllergySave = null;
        updateCheckoutState(getAllergyFieldset());
        return Promise.resolve(false);
      }
 
      pendingAllergySave = { seq: myAllergySeq };
      setAllergyControlsDisabled(true);
      updateCheckoutState(getAllergyFieldset());
 
      return saveAllergyDeclaration(attrs.status, attrs.allergies, attrs.notes, attrs.previousStatus, attrs.saveToProfile)
        .then(function () {
          if (myAllergySeq !== allergySeq) return false;
          pendingAllergySave = null;
          allergyPersisted = result.valid;
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(getAllergyFieldset());
          return result.valid;
        })
        .catch(function (err) {
          console.error('[Fi Akla] Failed to save allergy declaration:', err.message);
          if (myAllergySeq !== allergySeq) return false;
          pendingAllergySave = null;
          allergyPersisted = false;
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(getAllergyFieldset());
          showError('CartDrawer-AllergySaveError', true);
          return false;
        });
    }
 
    /* ── init() ────────────────────────────────────────────
       Each call gets its own sequence number.
       The fetchCartState() callback checks whether its
       sequence is still the latest before touching the DOM.  */
 
    function init() {
      var select = getSelect();
      var allergyFieldset = getAllergyFieldset();
      var checkout = getCheckout(select);
      if (!checkout) return;
 
      /* Never restore stale server state over a save that is still in flight. */
      if (pendingSlotSave !== null || pendingAllergySave !== null || pendingRoutingSave !== null) {
        debouncedInit();
        return;
      }
 
      /* Increment init counter and capture locally */
      initSeq += 1;
      var myInitSeq = initSeq;
 
      /* Immediately disable required controls while fetching. */
      slotPersisted = false;
      allergyPersisted = false;
      routingPersisted = false;
      compositionKnown = false;
      cartMode = 'empty';
      setSelectDisabled(true);
      setAllergyControlsDisabled(true);
      updateCheckoutState(select);
      showError('CartDrawer-DeliverySlotError',     false);
      showError('CartDrawer-DeliverySlotSaveError', false);
      showError('CartDrawer-DeliverySlotExpired',   false);
      showError('CartDrawer-RoutingSaveError',      false);
      hideAllergyErrors();
 
      var options = buildOptions();
      if (window.FiAklaDeliverySchedule) window.FiAklaDeliverySchedule.renderCountdowns();
 
      fetchCartState()
        .then(function (cart) {
          if (myInitSeq !== initSeq) return null;
          cartMode = getCartMode(cart);
          compositionKnown = true;
          syncCartModeUI();
          return persistRoutingAttributes(cart, myInitSeq);
        })
        .then(function (cart) {
          if (!cart || myInitSeq !== initSeq) return;
          var attrs = cart.attributes || {};
          cartMode = getCartMode(cart);
          compositionKnown = true;
          syncCartModeUI();

          var savedSlot = attrs['Delivery slot'] || '';
          var savedDate = attrs['_delivery_date'] || '';
          var savedWindow = attrs['_delivery_window'] || '';
          var match = options.find(function (option) {
            return option.date === savedDate && option.window === savedWindow;
          }) || (savedSlot ? findOption(savedSlot, options) : null);
          var slotValid = !!(
            cartMode === 'weekly' &&
            match &&
            match.date && match.date === savedDate &&
            match.window && match.window === savedWindow
          );
          var slotExpired = cartMode === 'weekly' && !!savedSlot && !slotValid;

          if (cartMode === 'meal-pass') {
            slotPersisted = true;
            allergyPersisted = true;
          } else {
            slotPersisted = slotValid;
            if (cartMode === 'weekly') populateSelector(options, slotValid ? match.value : '');
            allergyPersisted = restoreAllergyUI(attrs);
          }

          if (slotExpired) {
            pendingSlotSave = { expired: true };
            showError('CartDrawer-DeliverySlotExpired', true);
            updateCheckoutState(select || allergyFieldset);
            clearSlot()
              .then(function () {
                if (myInitSeq !== initSeq) return;
                pendingSlotSave = null;
                slotPersisted = false;
                setSelectDisabled(false);
                setAllergyControlsDisabled(false);
                syncAllergyVisibility();
                updateCheckoutState(select || allergyFieldset);
              })
              .catch(function (error) {
                if (myInitSeq !== initSeq) return;
                console.error('[Fi Akla] Failed to clear expired delivery slot:', error);
                pendingSlotSave = null;
                showError('CartDrawer-DeliverySlotSaveError', true);
                setSelectDisabled(false);
                setAllergyControlsDisabled(false);
                updateCheckoutState(select || allergyFieldset);
              });
            return;
          }
          setSelectDisabled(false);
          setAllergyControlsDisabled(false);
          syncAllergyVisibility();
          updateCheckoutState(select || allergyFieldset);
 
        })
        .catch(function (err) {
          if (myInitSeq !== initSeq) return;
          console.error('[Fi Akla] Failed to fetch cart:', err);
          pendingRoutingSave = null;
          routingPersisted = false;
          slotPersisted = false;
          allergyPersisted = false;
          compositionKnown = false;
          cartMode = 'empty';
          syncCartModeUI();
          populateSelector(options, '');
          clearAllergyUI();
          setSelectDisabled(false);
          setAllergyControlsDisabled(false);
          showError('CartDrawer-RoutingSaveError', true);
          updateCheckoutState(select);
        });
    }
 
    /* ── Debounced init ────────────────────────────────────── */
 
    var initTimer = null;
    function debouncedInit() {
      clearTimeout(initTimer);
      initTimer = setTimeout(init, 80);
    }

    function refreshSchedule() {
      if (window.FiAklaDeliverySchedule) {
        window.FiAklaDeliverySchedule.renderCountdowns();
      }

      var select = getSelect();
      if (!select) return;

      var nextOptions = buildOptions();
      var currentValues = Array.prototype.map.call(select.options, function (option) {
        return option.value;
      });
      var nextValues = nextOptions.map(function (option) {
        return option.value;
      });

      if (currentValues.join('\n') !== nextValues.join('\n')) {
        debouncedInit();
        return;
      }

      updateCheckoutState(select);
    }
 
    /* ── Slot change handler ───────────────────────────────── */
 
    function onSlotChange(event) {
      /* Match by attribute — not by element identity */
      var select = event.target;
      if (
        !select ||
        !select.matches ||
        !select.matches('select[name="attributes[Delivery slot]"]')
      ) {
        return;
      }
 
      showError('CartDrawer-DeliverySlotError',     false);
      showError('CartDrawer-DeliverySlotSaveError', false);
      showError('CartDrawer-DeliverySlotExpired',   false);
 
      slotPersisted = false;
 
      /* Bump both counters so any in-flight init() is treated as stale */
      changeSeq += 1;
      initSeq   += 1;
      var myChangeSeq = changeSeq;
 
      var selectedValue = select.value;
 
      if (!selectedValue) {
        pendingSlotSave = null;
        updateCheckoutState(select);
        clearSlot().catch(function (err) {
          console.error('[Fi Akla] Failed to clear slot:', err);
        });
        return;
      }
 
      var options = buildOptions();
      var match   = findOption(selectedValue, options);
 
      if (!match || !match.date) {
        select.value  = '';
        slotPersisted = false;
        pendingSlotSave = null;
        updateCheckoutState(select);
        showError('CartDrawer-DeliverySlotSaveError', true);
        return;
      }
 
      select.disabled = true;
      pendingSlotSave = { seq: myChangeSeq };
      updateCheckoutState(select);
 
      saveSlot(match.value, match.date, match.window)
        .then(function () {
          if (myChangeSeq !== changeSeq) return;
          pendingSlotSave = null;
          slotPersisted = true;
          select.disabled = false;
          updateCheckoutState(select);
          showError('CartDrawer-DeliverySlotError',     false);
          showError('CartDrawer-DeliverySlotSaveError', false);
        })
        .catch(function (err) {
          console.error('[Fi Akla] Failed to save slot:', err.message);
          if (myChangeSeq !== changeSeq) return;
          pendingSlotSave = null;
          slotPersisted = false;
          select.value = '';
          select.disabled = false;
          updateCheckoutState(select);
          showError('CartDrawer-DeliverySlotSaveError', true);
        });
    }
 
    /* ── Allergy declaration handlers ─────────────────────── */
 
    function onAllergyChange(event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('[data-allergy-status], [data-allergen], [data-allergy-profile-save]')) return;
 
      hideAllergyErrors();
 
      if (
        target.matches('[data-allergy-status]') &&
        (target.value === 'No known allergies' || target.value === 'Same as before')
      ) {
        var allergens = getAllergenInputs();
        for (var i = 0; i < allergens.length; i++) allergens[i].checked = false;
        var other = getAllergyOtherInput();
        var notes = getAllergyNotesInput();
        if (other) other.value = '';
        if (notes) notes.value = '';
      }
 
      if (target.matches('[data-allergen-other]') && !target.checked) {
        var otherInput = getAllergyOtherInput();
        if (otherInput) otherInput.value = '';
      }
 
      syncAllergyVisibility();
      persistAllergyFromUI(false);
    }
 
    function onAllergyInput(event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('[data-allergy-other-text], [data-allergy-notes]')) return;
 
      hideAllergyErrors();
      allergyPersisted = false;
      updateCheckoutState(target);
      clearTimeout(allergyInputTimer);
      allergyInputTimer = setTimeout(function () {
        persistAllergyFromUI(false);
      }, 400);
    }
 
    /* ── Form submit guard ─────────────────────────────────── */
 
    function onFormSubmit(event) {
      if (!event.target || event.target.id !== 'cart-form') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var checkout = document.querySelector('button[name="checkout"][form="cart-form"]');
      if (checkout && !checkout.disabled) beginCheckout(checkout);
    }

    var checkoutInProgress = false;
    var cartUpdating = false;
    async function onCheckoutClick(event) {
      var target = event.target;
      var checkout = target && target.closest && target.closest('button[name="checkout"][form="cart-form"]');
      if (!checkout || checkout.disabled) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      return beginCheckout(checkout);
    }

    async function beginCheckout(checkout) {
      if (checkoutInProgress || cartUpdating || !compositionKnown || !chefBookingsReady || cartMode === "empty") return;
      var select = getSelect();
      var selected = cartMode === 'weekly' && select ? findOption(select.value, buildOptions()) : null;
      if (cartMode === 'weekly' && (!selected || !selected.date || !readAllergyUI().valid)) {
        debouncedInit();
        return;
      }
      checkoutInProgress = true;
      checkout.disabled = true;
      try {
        var attrs = getRoutingAttributes(cartMode) || {};
        if (selected) {
          attrs['Delivery slot'] = selected.value;
          attrs['_delivery_date'] = selected.date;
          attrs['_delivery_window'] = selected.window;
        }
        await window.FiAklaCartIntegrity.prepareCheckout(attrs, selected && selected.value);
        window.location.assign(getCartRoute('checkout'));
      } catch (error) {
        console.error('[Fi Akla] Checkout verification failed', error);
        showError('CartDrawer-DeliverySlotSaveError', true);
        checkoutInProgress = false;
        debouncedInit();
      }
    }

    /* ── MutationObserver — detect cart drawer appearing ───── */
 
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            node.querySelector &&
            (node.matches('button[name="checkout"][form="cart-form"]') ||
             node.querySelector('button[name="checkout"][form="cart-form"]') ||
             node.querySelector('select[name="attributes[Delivery slot]"]') ||
             node.querySelector('#CartDrawer-AllergyDeclaration') ||
             node.id === 'CartDrawer-DeliverySlot' ||
             node.id === 'CartDrawer-AllergyDeclaration')
          ) {
            debouncedInit();
            return;
          }
        }
      }
    });
 
    observer.observe(document.body, { childList: true, subtree: true });
 
    /* ── Register event listeners (once, guarded by outer if) ─ */
 
    document.addEventListener('change', onSlotChange);
    document.addEventListener('change', onAllergyChange);
    document.addEventListener('input', onAllergyInput);
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onFormSubmit, true);
    document.addEventListener('cart:refresh', debouncedInit);
    document.addEventListener('shopify:section:load', debouncedInit);
    document.addEventListener('cart:updated', debouncedInit);
    document.addEventListener('fi-akla:cart-updating', function (event) {
      cartUpdating = !!event.detail;
      updateCheckoutState(getSelect());
      if (!cartUpdating) debouncedInit();
    });
    document.addEventListener('cart:open',    debouncedInit);
    document.addEventListener('fi-akla:contact-state', function () {
      updateCheckoutState(getSelect());
    });
    document.addEventListener('fi-akla:cart-cleanup-state', function () {
      updateCheckoutState(getSelect());
      if (!window.FiAklaCartIntegrity.isCleanupPending()) debouncedInit();
    });
    /* Refresh countdown text every minute, but only re-initialise the cart
       gate when the actual set of available delivery slots has changed.
       This avoids replacing a valid, clickable checkout state once a minute. */
    window.setInterval(refreshSchedule, 60000);
 
    /* ── Kick off ──────────────────────────────────────────── */
 
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', debouncedInit);
    } else {
      debouncedInit();
    }
 
  })();
}


